import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const WeeklyWarningChart = ({ data = [] }) => {
  const chartOptions = {
    chart: {
      type: "column",
    },
    title: {
      text: "Avertissements Hebdomadaires",
      align: "center",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: data.map((item) => item.name.slice(5)),
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Revenu",
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Avertissement",
        data: data.map((item) => parseInt(item.warning)),
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default WeeklyWarningChart;
